import React from 'react';

const City = (props) => {
  const { name } = props;

  return <h1 className="city">{name}</h1>;
};

export default City;
